import { ButtonType, PrimaryButton, toast } from '@systemeio/ui';
import { useDuplicateNewsletter } from 'modules/newsletters/single/hooks/use-duplicate-newsletter ';
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface';
import { getNewslettersEditorNextjsUrl } from 'modules/newsletters/single/utils/get-newsletters-editor-nextjs-url';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { CopyIcon } from '@systemeio/ui/icons';
interface DuplicateNewsletterModalProps {
  newsletterId: NewsletterId;
  isDisabled: ButtonType['isFetching'];
}
export const DuplicateNewsletterModal = ({
  newsletterId,
  isDisabled
}: DuplicateNewsletterModalProps) => {
  const {
    t
  } = useLocoTranslation();
  const router = useRouter();
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const fetcherDuplicateNewsletter = useDuplicateNewsletter();
  const handleConfirm = async (newsletterId_0: NewsletterId) => {
    try {
      const duplicatedNewsletterData = await fetcherDuplicateNewsletter(newsletterId_0);
      duplicatedNewsletterData && router.push(getNewslettersEditorNextjsUrl(duplicatedNewsletterData?.id as NewsletterId));
    } catch (e) {}
  };
  const onCloseHandle = () => {
    setIsOpened(false);
  };
  useEffect(() => {
    toast.success(<div>
        <TransLoco t={t} i18nKey={`dashboard.newsletter_editor.was_already_sent_message`} components={{
        span: <span onClick={() => setIsOpened(true)} className={'primary-link cursor-pointer'} />
      }} />
      </div>);
  }, []);
  return <React.Fragment>
      <PrimaryButton disabled={isDisabled} onClick={() => setIsOpened(true)}>
        <CopyIcon className={'fill-background-secondary h-[20px] w-[20px]'} />
        <span className="hidden lg:flex">{t('global.duplicate')}</span>
      </PrimaryButton>
      <ConfirmationModal confirmationText={t('dashboard.newsletter.duplicate_confirm')} opened={isOpened} onClose={onCloseHandle} onConfirm={() => {
      handleConfirm(newsletterId);
    }} />
    </React.Fragment>;
};